import { conditionFromCpsf, pickSimpleLeadImage } from './buildOpportunityCustomFields';

// Shape of one element in the `portfolioLeads` array sent to GHL/FUB.
// Used both when the lead is a true portfolio sibling and when it's a single
// lead being shipped as a "portfolio of one" — same shape either way.
export function buildPortfolioLeadEntry(lead) {
    const addr = lead?.address || {};
    const characteristics = lead?.verifiedCharacteristics || {};
    // Filtered pick — never a Drive/Dropbox folder URL or an operator-deleted photo.
    const image = pickSimpleLeadImage(lead);
    const occupancy = lead?.customFields?.tenantOccupied != null
        ? (lead.customFields.tenantOccupied ? 'Occupied' : 'Vacant')
        : null;

    return {
        address: addr.streetAddress || '',
        city: addr.city || '',
        state: addr.state || '',
        price: lead?.currentAskingPrice || 0,
        bedrooms: characteristics.bedrooms ?? null,
        bathrooms: characteristics.bathrooms ?? null,
        sqft: characteristics.livingSquareFeet ?? null,
        yearBuilt: characteristics.yearBuilt ?? null,
        image,
        occupancy,
        condition: conditionFromCpsf(lead?.underwriting?.repairCost, characteristics.livingSquareFeet),
        arv: lead?.underwriting?.arv ?? null,
        repairCost: lead?.underwriting?.repairCost ?? null,
    };
}

// Single-lead "portfolio of one" — built from the active lead + calculatorInputs so
// values match what's shown on the page (calculator overrides win over leadData).
export function buildSingleLeadEntry(lead, customFieldValues) {
    const addr = lead?.address || {};
    return {
        address: addr.streetAddress || '',
        city: addr.city || '',
        state: addr.state || '',
        price: customFieldValues['Price'] || 0,
        bedrooms: customFieldValues['Bedrooms'] ?? null,
        bathrooms: customFieldValues['Bathrooms'] ?? null,
        sqft: customFieldValues['Square Footage'] ?? null,
        yearBuilt: customFieldValues['Year Built'] ?? null,
        image: customFieldValues['Image'] || null,
        occupancy: customFieldValues['Occupancy'] || null,
        condition: customFieldValues['Condition'] || null,
        arv: customFieldValues['ARV'] || null,
        repairCost: customFieldValues['Repair Cost'] || null,
    };
}
